module.exports = __webpack_public_path__ + "static/media/pharmacodb-logo-dark.cd4abf48.png";